export const getCompanyDomain = () => window.location.hostname.split('.')[0];

export const isCompanyDomain = () => getCompanyDomain() !== 'www';
